import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Switch, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { RightsWrapper } from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllSource extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
    source: [],
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      //   this.setState({exportParams: params})
      let data = await this.getAllSource({
        ...params,
        regExFilters: []
      })
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000,
    })
    return response
  }

  handleSubmit = e => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateSourceDetails(values) //For Updating Data
        } else {
          x = await Request.addSourceDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
          })
          notification.success({
            message: this.state.id
              ? `Source Updated Successfully`
              : 'Source Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
              sourceName: '',
              sourceShortDescription: '',
              sourceDescription: ''
            })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteSourceDetails = async data => {
    this.setState({ loading: true })
    await Request.deleteSourceDetails(data)
    this.setState({ loading: false })
    this.table.current.reload();
    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setSourceDetailsData(companyDetailId) {
    if (companyDetailId) {
      Request.sourceDetailByID({ id: companyDetailId }).then(
        ({ doc, error, message }) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1'
            })
            this.props.form.setFieldsValue({
              sourceName: doc.sourceName,
              sourceShortDescription: doc.sourceShortDescription,
              sourceDescription: doc.sourceDescription
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  componentWillMount() {

  }


  changeSourceStatus = async (checked, _id) => {
    let response = await Request.updateSourceStatus({ _id, active: checked });
    if (response.success) {
      notification.success({
        message: response.msg
      })
    } else {
      notification.error({
        message: response.msg
      })
    }
    this.table.current.reload();
  }

  async componentDidMount() {
    await this.getAllSource();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const {
      form: { getFieldDecorator }
    } = this.props
    const { id } = this.state;

    const inputTypes = {
      fields: [
        {
          label: "Source Name",
          key: "sourceName",
          required: true
        },
        {
          label: "Source Short Description",
          key: "sourceShortDescription",
          required: true
        },
        {
          label: "Source Description",
          key: "sourceDescription",
          type: 'textarea',
          required: true
        }
      ]
    };

    const columns = [
      {
        title: 'Source Name',
        key: 'sourceName',
      },
      {
        title: 'Source Short Description',
        key: 'sourceShortDescription',
      },
      {
        title: 'Source Description',
        key: 'sourceDescription',
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          record.businessId ?
            <React.Fragment>
              <RightsWrapper myRight={'source.edit'}>
                <Tooltip title="Active/Inactive">
                  <Switch checked={record.active} onChange={(checked) => {
                    this.changeSourceStatus(checked, record._id)
                  }} />
                </Tooltip>
              </RightsWrapper>
              <RightsWrapper myRight={'source.edit'}>
                <Tooltip title="Edit Source">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    onClick={() => {
                      this.setSourceDetailsData(record._id)
                    }}
                    icon="edit"
                  />
                </Tooltip>
              </RightsWrapper>
              <RightsWrapper myRight={'source.delete'}>
                <Tooltip title="Delete Source">
                  <Popconfirm
                    title="Are you sure delete this Source?"
                    onConfirm={() => {
                      this.deleteSourceDetails({ _id: record._id })
                    }}
                    okText="Yes"
                    cancelText="No">
                    <Button
                      className={styles.btn}
                      shape="circle"
                      icon="delete"
                    />
                  </Popconfirm>
                </Tooltip>
              </RightsWrapper>
            </React.Fragment>
            : null
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Source Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Source`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Source'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllSource
